
import { computed, defineComponent, PropType } from 'vue'
import { CommonDatePicker } from '@/components'
import moment from 'moment'
import _ from 'lodash'

interface IDateRange {
  startDate: string | null
  endDate: string | null
}

export default defineComponent({
  name: 'DateRange',
  components: {
    CommonDatePicker
  },
  props: {
    value: { type: Object as PropType<IDateRange> },
    group: { type: String, default: 'default' },
    startRequied: { type: Boolean, default: false },
    endRequired: { type: Boolean, default: false },
    hideLabel: { type: Boolean, default: false },
    disable: { type: Boolean, default: false },
    allowNullValue: { type: Boolean, default: false },
    startDateLabel: { type: String, default: null },
    endDateLabel: { type: String, default: null },
    clearable: { type: Boolean, default: false },
    isHaveGuide: { type: Boolean, default: true },
    singleLine: { type: Boolean, default: false }
  },
  setup(props, { emit }) {
    // create two-way data bindings
    const dateRange = computed<IDateRange>({
      get() {
        return props.value as IDateRange
      },
      set(val: IDateRange) {
        emit('input', val)
      }
    })

    //model start date
    const startDate = computed({
      get() {
        return dateRange.value?.startDate || null
      },
      set(val: string) {
        dateRange.value = Object.assign(dateRange.value, {
          startDate: val
        })
      }
    })

    //model end date
    const endDate = computed({
      get() {
        return dateRange.value?.endDate || null
      },
      set(val: string) {
        dateRange.value = Object.assign(dateRange.value, {
          endDate: val
        })
      }
    })

    const isDateTimeRangeValid = () => {
      let isValid = true
      for (const key in dateRange.value) {
        if (!dateRange.value[key]) {
          emit('check-valid-date-range', isValid)
          return isValid
        }
      }
      const startDate = moment(dateRange.value.startDate)
      const endDate = moment(dateRange.value.endDate)
      if (!startDate.isBefore(endDate)) isValid = false

      emit('check-valid-date-range', isValid)
      return isValid
    }

    return { startDate, endDate, isDateTimeRangeValid }
  }
})
